import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BillingService } from 'src/app/shared/services/billing/billing.service';
import { HelpService } from 'src/app/shared/services/help.service';
import { ShipmentMasterService } from 'src/app/shared/services/shipment-master.service';

@Component({
  selector: 'app-preprogram-dialog',
  templateUrl: './preprogram-dialog.component.html',
  styleUrls: ['./preprogram-dialog.component.scss'],
  standalone: false,
})
export class PreprogramDialogComponent implements OnInit {
  isLoading = false;
  preprogramForm: FormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<PreprogramDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      shipmentId: number;
      loadId: number;
      amount: number;
    },
    private readonly formBuilder: FormBuilder,
    private readonly helpService: HelpService,
    private readonly billingService: BillingService,
    private readonly shipmentMasterService: ShipmentMasterService,
    private readonly authService: AuthService
  ) {}

  ngOnInit() {
    this.createPreprogramForm();
  }

  createPreprogramPricesheet(): void {
    this.isLoading = true;
    const formData = {
      ShipmentId: Number(this.preprogramForm.value.ShipmentId),
      Amount: Number(this.preprogramForm.value.Amount),
      CreateUser: this.authService.userEmail
    };

    this.billingService
      .createManualPreProgramPricesheet(formData)
      .subscribe({
        next: () => {
          this.helpService.showMessageNotification(
            'Preprogram pricesheet successfully created',
            'success'
          );
          this.isLoading = false;
          this.shipmentMasterService.getShipmentAndLoad(
            this.data.shipmentId,
            this.data.loadId
          );
          this.dialogRef.close(true);
        },
        error: () => {
          this.helpService.showMessageNotification(
            'Error! Please try again.',
            'danger'
          );
          this.isLoading = false;
        },
      });
  }

  private createPreprogramForm(): void {
    this.preprogramForm = this.formBuilder.group({
      ShipmentId: [this.data.shipmentId, Validators.required],
      Amount: [this.data.amount, Validators.required],
    });
  }
}
